import $ from 'jquery';
import Swal from 'sweetalert2';
import {
  unity,
  stores,
  funcionalByWorkplace,
  cdType,
  area,
  resetUnitiesValue,
  resetStoresValue,
  resetFuncionalValue,
  resetCdTypeValue,
  resetAreaValue,
} from '../../modules/select';

export const presencesIndex = () => {
  bindActions();
  unity();
  stores();
  funcionalByWorkplace();
  cdType();
  area();
};

const resetSelects = () => {
  resetUnitiesValue();
  resetStoresValue();
  resetFuncionalValue();
  resetCdTypeValue();
  resetAreaValue();
};

const bindActions = () => {
  let $errorMsg = $('.js-participantes-error');

  $('.js-check-volunteers').on('click', function (e) {
    e.preventDefault();

    $errorMsg.hide();

    let employees = $('.employee').filter(':checked').length;
    let externals = $('.external').filter(':checked').length;

    $('#js-total-employees').html(employees);
    $('#js-total-external').html(externals);

    $('#js-total-employees-text').html(employees == 1 ? 'Associado(a)' : 'Associados');
  });

  $('.js-presence-validate').on('click', function (e) {
    let $errorMsg = $('.js-participantes-error');

    if ($('.employee').filter(':checked').length + $('.external').filter(':checked').length <= 0) {
      e.preventDefault();
      $errorMsg.show();
    } else {
      $errorMsg.hide();
    }
  });

  $('.js-checkall').on('click', function (e) {
    e.preventDefault();
    if (!$("input[name='js-checkall']").prop('checked')) $('input[type=checkbox]').prop('checked', true);
    else $('input[type=checkbox]').prop('checked', false);
  });

  $('.js-form-search').on('keyup', function (e) {
    e.preventDefault();
    w3.filterHTML('.table', '.subscribe-user', $(this).val());
  });

  $('.js-adduser').on('click', function (e) {
    e.preventDefault();
    $('#presence-list').removeClass('active');
    $('#presence-add').addClass('active');
  });

  $('.js-cancell-adduser').on('click', function (e) {
    e.preventDefault();
    $('#presence-list').addClass('active');
    $('#presence-add').removeClass('active');
    $('#guests-table').html('');
  });

  $(document).on('click', '.js-close-panel', function (e) {
    e.preventDefault();
    $('.c-search--panel').addClass('u-display--none');
    $('#new-guest').addClass('u-display--none');
  });

  $(document).on('click', '.js-new-guest', function (e) {
    e.preventDefault();
    $('.js-form-add-users').val();
    $('#js-results').html('');
    $('#new-guest').removeClass('u-display--none');
    $('.c-search--panel-message').addClass('u-display--none');
  });

  $(document).on('keyup', '.js-form-add-users', function (e) {
    e.preventDefault();
    $('.c-search--panel-message').removeClass('u-display--none');

    if ($(this).val().length >= 1) {
      $('.c-search--panel').removeClass('u-display--none');
    } else {
      $('.c-search--panel').addClass('u-display--none');
    }

    if ($(this).val().length >= 3) {
      $('.c-message--label').addClass('u-display--none');

      var post = {};

      post.term = $(this).val();
      post._token = $('meta[name="csrf-token"]').attr('content');
      post.challenge_id = $(this).attr('data-challenge');

      $.ajax({
        type: 'POST',
        url: '/pesquisa-voluntarios/' + post.term + '/challenge',
        data: post,
        dataType: 'json',
        success: function (data) {
          $('#js-results').html(data.html);
        },
      });
    } else {
      $('#new-guest').addClass('u-display--none');
      $('.c-message--label').removeClass('u-display--none');
      $('#js-results').html('');
    }
  });

  $(document).on('change', '.js-volunteer-type', function () {
    if ($("input[name='volunteer_type']:checked").val() == 'employee') {
      $('#associado').show();
    } else {
      $('#associado').hide();
    }
  });

  $(document).on('change', '.js-type', function () {
    const type = $(this).val();
    const arrFields = $('[data-type]');

    resetSelects();

    if (type) {
      arrFields.map(function (i, el) {
        let types = $(el).data('type').split(' ');
        if (types.includes(type)) {
          $(el).show();
        } else {
          $(el).hide();
        }
      });
    } else {
      arrFields.hide();
    }
  });

  $(document).on('click', '.js-add-presence', function (e) {
    e.preventDefault();

    var post = {};

    post.challenge_id = $(this).attr('data-challenge');
    post.user_id = $(this).attr('data-user');
    post._token = $('meta[name="csrf-token"]').attr('content');

    var url = '/efetuar-inscricao/challenge';

    $.ajax({
      type: 'POST',
      url: url,
      data: post,
      dataType: 'json',
      success: function (data) {
        if (data.type === 'success') {
          $('#subscribes-table').append(data.html);
          $('#guests-table').append(data.html);
          $('#counter').html(data.subscribes);

          Swal.fire(data.title, data.message, data.type);

          $('.js-form-add-users').text = '';
          $('.c-search--panel').addClass('u-display--none');
        } else {
          Swal.fire(data.title, data.message, data.type);
        }
      },
    });

    return false;
  });

  function validate() {
    let validated = true;

    if ($("input[name='name']").val() == '') {
      console.log('não preencheu nome');
      validated = false;
    }

    if ($("input[name='email']").val() == '') {
      console.log('não preencheu email');
      validated = false;
    }

    if ($("input[name='volunteer_type']:checked").val() == null) {
      console.log('não deu check no tipo');
      validated = false;
    }

    if ($("input[name='volunteer_type']:checked").val() == 'employee') {
      console.log('é empregado');

      if (!$('#user_type').val()) {
        console.log('não preencheu o tipo');
        validated = false;
      }

      if ($("input[name='enrollment']").val() == '') {
        console.log('não preencheu a matricula');
        validated = false;
      }

      if ($('[name="funcional_id"]').val() == '') {
        console.log('não preencheu o cargo');
        validated = false;
      }

      if ($('#user_type').val() == 'ec') {
        console.log('é EC');
        if ($('[name="area_id"]').val() == '') {
          console.log('não preencheu a area');
          validated = false;
        }
      }

      if ($('#user_type').val() == 'store') {
        console.log('é Loja');
        if ($('[name="unity_id"]').val() == '') {
          console.log('não preencheu a unidade');
          validated = false;
        }
        if ($('[name="store_id"]').val() == '') {
          console.log('não preencheu a loja');
          validated = false;
        }
      }

      if ($('#user_type').val() == 'cd') {
        console.log('é CD');
        if ($('[name="cd_type"]').val() == '') {
          console.log('não preencheu o CD');
          validated = false;
        }
      }
    }
    return validated;
  }

  $(document).on('click', '.js-add-presence-user', function (e) {
    e.preventDefault();

    if (!validate()) {
      Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
    } else {
      var form = $(this).closest('form');
      var post = form.serialize();

      $.ajax({
        type: 'POST',
        url: '/visitante',
        data: post,
        dataType: 'json',
        success: function (data) {
          if (data.type === 'success') {
            $('#subscribes-table').append(data.html);
            $('#guests-table').append(data.html);
            $('#counter').html(data.subscribes);
            $('#associado').hide();
            form.trigger('reset');
            $('.c-search--panel').addClass('u-display--none');

            Swal.fire(data.title, data.message, data.type);
          } else {
            Swal.fire(data.title, data.message, data.type);
          }
        },
      });
    }
  });

  $('.continue').on('click', function (e) {
    e.preventDefault();

    let currentSlide = $(this).attr('data-current');
    let nextSlide = $(this).attr('data-next');

    if (currentSlide == 'volunteers') {
      if ($("input[name='total_employees']").val() == '') {
        Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
        return false;
      }
    }

    if (currentSlide == 'hours') {
      if ($("input[name='total_time_action']").val() == '') {
        Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
        return false;
      }
    }

    if (currentSlide == 'benefiteds') {
      if (
        $("input[name='total_benefited_child']").val() == '' ||
        $("input[name='total_young']").val() == '' ||
        $("input[name='total_adults']").val() == '' ||
        $("input[name='total_seniors']").val() == ''
      ) {
        Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
        return false;
      }
    }

    $('#' + currentSlide).removeClass('active');
    $('#' + nextSlide).addClass('active');
  });

  $('.back').click(function (e) {
    e.preventDefault();

    let currentSlide = $(this).attr('data-current');
    let nextSlide = $(this).attr('data-next');

    if (nextSlide == 'rede') {
      if ($("input[name='volunteer_type']:checked").val() == 'employee') {
        nextSlide = 'rede';
      } else {
        nextSlide = 'state';
      }
    }

    $('#' + currentSlide).removeClass('active');
    $('#' + nextSlide).addClass('active');
  });
};
